import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Principal from '@/components/Principal'
import Compilacao from '@/components/Compilacao'
import RSessao from '@/components/Rest/RSessao'
import AcompanhamentoVendas from '@/components/AcompanhamentoVendas'
import VendasPorVendedor from '@/components/VendasPorVendedor'
import Dashboard from '@/components/Dashboard/Dashboard'
import Mensagens from '@/components/Mensagens'
import ControleGerencial from '@/components/ControleGerencial'
import CancelarFechamentoPedido from '@/components/CancelarFechamentoPedido'
import MapaFinanceiro from '@/components/MapaFinanceiro'
import AfericaoLucro from '@/components/AfericaoLucro'
import AfericaoLucro2 from '@/components/AfericaoLucro2'
import ClientesSimplificados from '@/components/ClientesSimplificados'
import VerificarPatrimonio from '@/components/VerificarPatrimonio'
import ConfirmarSaidaProdutos from '@/components/ConfirmarSaidaProdutos'
import Manifestos from '@/components/Manifestos'
import Contagens from '@/components/Contagens'
import Sugestoes from '@/components/Sugestoes'
import NaoAutorizado from '@/components/NaoAutorizado'
import NaoEncontrado from '@/components/NaoEncontrado'
import Orcamentos from '@/components/Orcamentos/Orcamentos'
import VidaCliente from '@/components/VidaCliente'
import VisoesFinanceiras from '@/components/VisoesFinanceiras'
import LoginTerceiros from '@/components/LoginTerceiros'
import PrincipalTerceiros from '@/components/PrincipalTerceiros'
import MenuTerceiros from '@/components/MenuTerceiros'
import CotacoesFornecedores from '@/components/CotacoesFornecedores'
import LogsADMServicos from '@/components/LogsADMServicos'
import LogServidor from '@/components/LogServidor'
import AcessosADMWeb from '@/components/AcessosADMWeb'
import GerenciarSugestoes from '@/components/GerenciarSugestoes'
import CarteiraCliente from '@/components/CarteiraCliente'
import swal from 'sweetalert'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/login-terceiros',
      name: 'LoginTerceiros',
      component: LoginTerceiros,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: true,
        usuario_motorista: true
      }
    },
    {
      path: '/logs/logs-admservicos',
      name: 'LogsADMServicos',
      component: LogsADMServicos,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/logs/logs-servidor',
      name: 'LogServidor',
      component: LogServidor,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/acessos-admweb',
      name: 'AcessosADMWeb',
      component: AcessosADMWeb,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/principal-terceiros',
      name: 'PrincipalTerceiros',
      component: PrincipalTerceiros,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: true,
        usuario_motorista: true
      }
    },
    
    {
      path: '/menu-terceiros',
      name: 'MenuTerceiros',
      component: MenuTerceiros,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: true,
        usuario_motorista: true
      }
    },
    {
      path: '/cotacoes-fornecedores',
      name: 'CotacoesFornecedores',
      component: CotacoesFornecedores,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: true,
        usuario_motorista: false
      }
    },
    {
      path: '/login',
      name: 'LoginAdm',
      component: Login,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    
    {
      path: '/principal',
      name: 'Principal',
      component: Principal,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/compilacao',
      name: 'Compilacao',
      component: Compilacao,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/manifestos',
      name: 'Manifestos',
      component: Manifestos,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: false,
        usuario_motorista: true
      }
    },
    {
      path: '/contagens-estoque',
      name: 'Contagens',
      component: Contagens,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/vida-cliente',
      name: 'VidaCliente',
      component: VidaCliente,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/confirmar-saida-produtos',
      name: 'ConfirmarSaidaProdutos',
      component: ConfirmarSaidaProdutos,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/visoes-financeiras',
      name: 'VisoesFinanceiras',
      component: VisoesFinanceiras,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false,
        funcionalidade_bloqueada: true
      }
    },
    {
      path: '/gerenciar-sugestoes',
      name: 'GerenciarSugestoes',
      component: GerenciarSugestoes,
      meta: {
        requer_autenticacao_adm: true,
        requer_autenticacao_fornecedor: false
      }
    },
    {
      path: '/carteira-cliente',
      name: 'CarteiraCliente',
      component: CarteiraCliente,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/mapa-financeiro',
      name: 'MapaFinanceiro',
      component: MapaFinanceiro,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false,
        funcionalidade_bloqueada: true
      }
    },
    {
      path: '/afericao-lucro',
      name: 'AfericaoLucro',
      component: AfericaoLucro,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false,
        funcionalidade_bloqueada: true
      }
    },

    {
      path: '/afericao-lucro2',
      name: 'AfericaoLucro2',
      component: AfericaoLucro2,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false,
        funcionalidade_bloqueada: true
      }
    },
  
    {
      path: '/acompanhamento-vendas',
      name: 'AcompanhamentoVendas',
      component: AcompanhamentoVendas,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }  
    },
    {
      path: '/vendas-por-vendedor',
      name: 'VendasPorVendedor',
      component: VendasPorVendedor,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/clientes-simplificados',
      name: 'ClientesSimplificados',
      component: ClientesSimplificados,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/verificar-patrimonio',
      name: 'VerificarPatrimonio',
      component: VerificarPatrimonio,
      meta: {
        requer_autenticacao_adm: true,
        requer_autenticacao_fornecedor: false,
        funcionalidade_bloqueada: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/mensagens',
      name: 'Mensagens',
      component: Mensagens,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/cancelar-fechamento-pedido',
      name: 'CancelarFechamentoPedido',
      component: CancelarFechamentoPedido,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/nao-autorizado',
      name: 'NaoAutorizado',
      component: NaoAutorizado,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/nao-encontrado',
      name: 'NaoEncontrado',
      component: NaoEncontrado,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/Sugestoes',
      name: 'Sugestoes',
      component: Sugestoes,
      meta: {
        precisa_logar: false,
        usuario_adm: false,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },
    {
      path: '/controle-gerencial',
      name: 'ControleGerencial',
      component: ControleGerencial,
      meta: {
        precisa_logar: true,
        usuario_adm: true,
        usuario_fornecedor: false,
        usuario_motorista: false
      }
    },

    /* --------------- SEMPRE POR ÚLTIMO --------------- */
    {
      path: '/principal/:parametros',
      name: 'Principal',
      component: Principal,
      meta: {
        requer_autenticacao_adm: true,
        requer_autenticacao_fornecedor: false
      }
    },
    /* Não colocar nada aqui */
  ]
})

let buscarPaginaLogin = function(precisa_logar, usuario_adm, usuario_fornecedor) {
  if ((!precisa_logar) || (usuario_adm)) {
    return '/';
  }

  if (!usuario_fornecedor) {
    return '/login-terceiros';
  }

  return '/';
}

router.beforeEach((to, from, next) => {
  let precisa_logar = to.matched.some(record => record.meta.precisa_logar);
  let usuario_adm = to.matched.some(record => record.meta.usuario_adm);
  let usuario_fornecedor = to.matched.some(record => record.meta.usuario_fornecedor);
  let usuario_motorista = to.matched.some(record => record.meta.usuario_motorista);

  // Antigo redirecionamento do login de fornecedores
  if (to.fullPath == '/login-fornecedores') {
    next('/login-terceiros');
    return;
  }
    
  /* 1º caso - páginas exceções que são sempre liberadas */
  if (to.fullPath == '/compilacao') {
    next();
    return;
  }

  if (to.fullPath == '/logs/logs-admservicos') {
    next();
    return;
  }

  let tela = to.fullPath;
  if (tela && (tela.startsWith('/vendas/orcamentos'))) {
    tela = '/vendas/orcamentos';
  } else if (tela && ((tela.startsWith('/?pagina=DASHBOARD')) || (tela.startsWith('/?pagina=CARTEIRA')))) {
    tela = '/';
  }

  let parametros = {
    tela: tela
  }

  RSessao.buscarAutorizacaoTela(Vue.axios, parametros)
  .then((retorno) => {
    /* 2º caso - retorno fracassado do servidor direciona para o login */
    if ((!retorno) || (!retorno.houve_erro) || (!retorno.houve_erro == 'S')) {
      next(buscarPaginaLogin(precisa_logar, usuario_adm, usuario_fornecedor));
      return;
    }

    let resultado = retorno.dados;
    if (!resultado) {
      next(buscarPaginaLogin(precisa_logar, usuario_adm, usuario_fornecedor));
      return;
    }

    /* 3º caso - usuário não está liberado */
    /*   - estando logado, vai para a tela NÃO AUTORIZADO    */
    /*   - não estando logado, vamos direcionar para o login */
    
    if (resultado.liberado != 'S') {
      if (resultado.logado == 'S') {
        next('/nao-autorizado');
      }
      else {
        next(buscarPaginaLogin(precisa_logar, usuario_adm, usuario_fornecedor));
      }

      return;
    }

    /* 4º caso - Estando o usuário logado com sucesso, se ele tentar acessar a tela de login */
    /* vamos direciona-lo para a tela principal */
    if 
      (
        (to.fullPath == '/') ||
        (to.fullPath == '/login') || 
        (to.fullPath == '/login-terceiros')
      ) 
    {
      if (resultado) {
        if (resultado.tipo_autenticacao == 'UAD'){
          next('/principal');
          return;
        } else if 
          (
            (resultado.tipo_autenticacao == 'FRN') ||
            (resultado.tipo_autenticacao == 'MOT')
          )
        {
          next('/principal-terceiros');
          return;
        }
      }
    }

    /* 5º caso - Protegendo o acesso a cotação de usuário que não são fornecedores */
    if 
      (
        (resultado.tipo_autenticacao != 'FRN') &&
        (to.fullPath == '/cotacoes-fornecedores')
      )
    {
      next('/nao-autorizado'); 
      return;
    }
    
    /* 6º caso - Protegendo o acesso ao manifesto de usuário que não são usuário ADM ou motorista */
    if 
      (
        (
          (resultado.tipo_autenticacao != 'UAD') &&
          (resultado.tipo_autenticacao != 'MOT')
        ) &&
        (to.fullPath == '/manifestos')
      )
    {
      next('/nao-autorizado'); 
      return;
    }

    if (to.matched.some(record => record.meta.funcionalidade_bloqueada)) {
      swal({
        title: 'Funcionalidade bloqueada',
        text: 'Entre em contato com a Santri para usar esta funcionalidade.',
        icon: 'warning',
        button: 'OK',
        className: 'swal-funcionalidade-bloqueada'
      });
      next(false);
      return;
    }

    /* 7º caso - Estando o usuário logado e autorizado, ele vai acessar a tela livremente */
    next();
  })
  .catch(async(erro) => {
    let url = buscarPaginaLogin(precisa_logar, usuario_adm, usuario_fornecedor);
    if (url == to.fullPath) {
      next();
    }
    else {
      next(url);
    }
  });
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js